var render = function render(){var _vm=this,_c=_vm._self._c;return _c('deployment-status-badge',{attrs:{"status":_vm.status,"href":_vm.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }